/**
 * A global namespace for `orientationchange` event.
 */
const orientationchangeEvent = 'orientationchange';
export default orientationchangeEvent;
